export const product = {
  productDetails: {
    id: 'ID',
    quantity: 'Qty',
    productDetails: 'Product Details',
    specification: 'Specs',
    reviews: 'Reviews',
    shipping: 'Shipping',
    share: 'Share',
    showReviews: 'Show reviews',
    noReviews: 'No reviews yet',
    productPrice: 'Product price',
  },
  productList: {
    noResult: {
      title: 'Wir haben leider keine Produkte gefunden',
      message:
        'Für Ihre Filtereinstellung konnten wir leider keine passenden Produkte finden. Ändern Sie Ihre Filter, um weiter zu stöbern.',
    },
    filterBy: {
      label: 'Filter by',
      action: 'Filter by',
    },
    appliedFilter: 'Applied filter:',
    showLess: 'Show less...',
    showMore: 'Show more...',
    sortBy: 'Sort by',
    backToTopBtn: 'BACK TO TOP',
    showMoreBtn: 'SHOW MORE',
    productSearchPagination: 'Product search pagination',
  },
  productFacetNavigation: {
    filterBy: {
      label: 'Filter by',
      action: 'Filter by',
    },
    appliedFilter: 'Applied filter:',
    showLess: 'Show less...',
    showMore: 'Show more...',
    sortBy: 'Sort by',
  },
  productSummary: {
    id: 'ID',
    showReviews: 'Show reviews',
    share: 'Share',
    newItemPrice: 'New item price',
  },
  productReview: {
    overallRating: 'Overall Rating',
    reviewTitle: 'Review Title',
    writeYourComments: 'Write your comments',
    rating: 'Rating',
    reviewerName: 'Reviewer name (optional)',
    writeReview: 'Write a Review',
    more: 'Show More Reviews',
    less: 'Show Less Reviews',
    thankYouForReview:
      'Vielen Dank für die Bewertung! Bitte beachte, dass die Rezensionen überprüft werden müssen, bevor sie hier erscheinen können.',
    createFirstReview:
      'Es sind noch keine Bewertungen für dieses Produkt vorhanden. Möchtest Du die erste Bewertung schreiben?',
  },
  addToCart: {
    itemsAddedToYourCart: 'Item(s) added to your cart',
    itemsIncrementedInYourCart: 'This item was already in your cart. The quantity was updated.',
    items: 'items',
    updatingCart: 'Updating cart...',
    addToCart: 'Add to cart',
    viewCart: 'view cart',
    proceedToCheckout: 'proceed to checkout',
    quantity: 'Qty',
    outOfStock: 'Out of stock',
    inStock: 'In stock',
    selectStyleAndSize: 'Select style and size to check stock',
    removeFromCart: 'Remove Product from Cart',
    closeModal: 'Close Modal',
  },
  TabPanelContainer: {
    tabs: {
      ProductDetailsTabComponent: 'Produktbeschreibung',
      ProductHintsTabComponent: 'Hinweise',
      ProductCertificatesTabComponent: 'Zertifikate',
      ProductReviewsTabComponent: 'Bewertungen',
      ProductQuestionsTabComponent: 'Fragen zum Produkt',
      ProductSizeTabComponent: 'Größen',
      ProductSpecsTabComponent: 'Produktmerkmale',
      ProductPdfsTabComponent: 'Downloads',
    },
  },
  addToWishList: {
    add: 'Add to Wish List',
    remove: 'Remove from Wish List',
    anonymous: 'Sign in to add to wish list',
  },
  stockNotification: {
    notifyMe: 'NOTIFY ME',
    stopNotify: 'STOP NOTIFICATION',
    getNotify: 'Get notified when this product is available.',
    getNotifySuffix: 'to get notified when this product is available.',
    activateChannelsPrefix: 'To be notified you need to activate the ',
    channelsLink: 'Notification Channels',
    activateChannelsSuffix: '.',
    inputLabel: 'Deine E-Mail Adresse...*',
    notified: 'Wir benachrichtigen Sie, wenn das Produkt wieder auf Lager ist.',
    getNotified: 'Get notified when this product is back in stock.',
    unsubscribeSuccess: 'You will not receive back-in-stock notification for this product.',
    subscriptionDialog: {
      header: 'Out of stock subscription',
      notifiedPrefix: 'You will be notified on:',
      notifiedSuffix: 'as soons as this product is back in stock.',
      manageChannelsPrefix: 'Manage your prefered notification channels at the ',
      manageChannelsLink: 'Notification Preference',
      manageChannelsSuffix: ' page.',
      manageSubscriptionsPrefix: 'You can manage your subscriptions at ',
      manageSubscriptionsLink: 'My Interests',
      manageSubscriptionsSuffix: ' page.',
      okBtn: 'OK',
      subscribing: 'Subscribing you to Out of Stock notifications for this product',
    },
  },
  itemCounter: {
    removeOne: 'Remove one',
    addOneMore: 'Add one more',
    quantity: 'Quantity',
  },
  productView: {
    gridView: 'Select to change to Grid View',
    listView: 'Select to change to List View',
  },
  backtostockModal: {
    title: 'Benachrichtigung aktivieren',
    subtitle: 'Wir benachrichtigen Sie, wenn das Produkt wieder auf Lager ist.',
    button: 'Benachrichtigen Sie mich',
    notifyMe: 'Benachrichtigen',
  },
};
